<template>
    <div class="goods_des">
        <div class="title flex">
            <div class="title_t" @click="onPage('des')">
                <img src="../../../assets/image/one/fanhui.png" alt="">
                <span>{{ val }}USD{{ $t('yi17') }}</span>
                <div></div>
            </div>
        </div>

        <div class="goods">
            <div class="goods_box">
                <!-- <div class="activity_tips" v-if="showActivityTips">
                    <div class="tips_txt">
                        {{ localObjData.slots_sold === localObjData.max_slots ? '开奖中，请稍候...' : 
                        '当前期活动已结束，\n新一期即将加载...' }}
                    </div>
                </div> -->
                <div class="goods_box_tie">
                    <span>{{ $t('yi18') }}{{ localObjData.phase_sn || '$' }}{{ $t('yi19') }}</span>
                    <!-- <span class="countdown">{{ formatCountdown(localObjData.remainingTime) }}</span> -->
                </div>
                <div class="goods_box_le">
                    <img :src="localObjData.goods_image" alt="">
                    <div class="goods_box_le_text">
                        <div> {{ localObjData.goods_name || '' }}</div>
                        <div style="margin-top: 10px;">{{ $t('yi20') }}<span>{{ localObjData.usd || 0 }}USD</span></div>
                    </div>
                </div>
                <div class="goods_box_ri">
                    <p class="progress">
                        <span
                            :style="'width: ' + ((localObjData.slots_sold / localObjData.max_slots) * 100).toFixed(2) + '%'"></span>
                    </p>
                    <div class="goods_box_ri_box">
                        <div>
                            <span>{{ localObjData.slots_sold || 0 }}</span>
                            <p>{{ $t('yi9') }}</p>
                        </div>
                        <div>
                            <span>{{ localObjData.max_slots || 0 }}</span>
                            <p>{{ $t('yi10') }}</p>
                        </div>
                        <div>
                            <span>{{ (Number(localObjData.max_slots) - Number(localObjData.slots_sold)) || 0 }}</span>
                            <p>{{ $t('yi11') }}</p>
                        </div>
                    </div>

                    <div class="buy_box" style="margin-top: 10px;margin-bottom: 0;"
                        v-if="localObjData.slots_sold !== localObjData.max_slots">
                        <div class="phase-sn">
                            {{ $t('yi18') }}
                            {{ localObjData.phase_sn || '$' }}
                            {{ $t('yi19') }}
                        </div>
                        <div>
                            <van-stepper v-model="value" input-width="40px" button-size="16px"/>
                        </div>
                        <div class="btn" @click="onBuy">{{ $t('yi40') }}</div>
                    </div>
                    <div class="goods_box_ri_btn" v-else>
                        <div>{{ $t('new24') }}</div>
                    </div>
                </div>
            </div>

            <!-- <div class="buy">
                <div class="buy_title">{{ $t('yi39') }}</div>

                <div class="buy_box" v-for="(el, i) in buy" :key="i">
                    <div class="phase-sn">
                        {{ el.phase_sn || '$' }}
                    </div>
                    <div>
                        <van-stepper v-model="el.number" input-width="45px" button-size="16px"/>
                    </div>
                    <div class="btn" @click="onAdvanceBuy(el)">{{ $t('yi40') }}</div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { Dialog } from 'vant';
import { Buy, GetActivityInfo, AdvanceBuy } from '../../../api/memberOne';

export default {
    props: {
        val: {
            default: '',
            type: [String, Number],
        },
        objData: {
            default: () => ({}),
            type: Object
        }
    },
    data() {
        return {
            value: 1,
            buy: [],
            showModal: false,
            isSucc: '',
            buyList: [],
            NexNun: '',
            cycle_id: 0,
            goods_id: 0,
            localObjData: { ...this.objData },
            intervalId: null, // 用于存储定时器的 ID
            showActivityTips: false // 用于显示活动提示
        }
    },
    created() {
        this.cycle_id = this.localObjData.cycle_id;
        this.goods_id = this.localObjData.goods_id;
        // this.startCountdown();
    },
    mounted() {
        this.load_phase_sn(this.localObjData);
    },
    beforeDestroy() {
        // 清除定时器
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
    watch: {
        objData: {
            handler(newVal) {
                this.localObjData = { ...newVal }; // 同步 prop 的变化
                this.load_phase_sn(this.localObjData);
            },
            deep: true // 深度监听对象变化
        }
    },
    methods: {
        //未完成的: 已经买满时,倒计时要停止
        startCountdown() {
            this.intervalId = setInterval(() => {
                if (this.localObjData.remainingTime > 0) {
                    this.localObjData.remainingTime = Math.max(0, this.localObjData.remainingTime - 1);
                } else {
                    // 显示活动提示
                    this.showActivityTips = true;
                    // 倒计时结束后5秒调用
                    clearInterval(this.intervalId);
                    setTimeout(this.onGetActivityInfo, 5000);
                }
            }, 1000);
        },
        onGetActivityInfo() {
            GetActivityInfo({
                cycle_id: this.cycle_id,
                goods_id: this.goods_id,
            }, 'one').then(res => {
                if (res && res.result) {
                    // if (res.result.phase_sn === this.localObjData.phase_sn) {
                    //     // 如果 phase_sn 相同，等待5秒后再次请求
                    //     setTimeout(this.onGetActivityInfo, 5000);
                    // } else {
                        // 否则，更新数据并隐藏活动提示
                        this.localObjData = res.result;
                        // this.localObjData.remainingTime = res.result.deadline_time;
                        // this.showActivityTips = false;
                        // this.startCountdown(); // 重新启动倒计时
                    // }
                }
            });
        },
        formatCountdown(timeLeftInSeconds) {
            let timeLeft = timeLeftInSeconds * 1000;

            timeLeft = Math.max(0, timeLeft);

            const hours = String(Math.floor(timeLeft / (1000 * 60 * 60))).padStart(2, '0');
            const minutes = String(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
            const seconds = String(Math.floor((timeLeft % (1000 * 60)) / 1000)).padStart(2, '0');

            return `${hours}:${minutes}:${seconds}`;
        },
        onShow() {
            this.showModal = true;
        },
        updateShow() {
            this.showModal = false;
        },
        onPage(v) {
            this.$emit('onPage', v);
        },
        // 加载预购期数
        load_phase_sn(objData) {
            this.buy = [];
            for (let i = 0; i < 5; i++) {
                let data = {
                    goods_id: objData.goods_id,
                    cycle_id: objData.cycle_id,
                    phase_sn: Number(objData.phase_sn) + 1 + Number(i),
                    phase: Number(objData.phase) + 1 + Number(i),
                    number: 1,
                };
                this.buy.push(data);
            }
        },
        // 预售购买
        onAdvanceBuy(data) {
            Dialog.confirm({
                title: this.$t('yi18') + data.phase + this.$t('yi19'),
                message: this.$t('hunt61') + data.number,
                confirmButtonText: this.$t('MessageBox.Confirm'),
                cancelButtonText: this.$t('MessageBox.Cancel'),
            }).then(() => {
                AdvanceBuy({
                    ...data
                }, 'one').then(res => {
                    Dialog.alert({message: res.message, confirmButtonText:this.$t('MessageBox.Confirm')})
                });
            });
        },
        // 购买
        onBuy() {
            Dialog.confirm({
                title: this.$t('yi18') + this.localObjData.phase_sn + this.$t('yi19'),
                message: this.$t('hunt61') + this.value,
                confirmButtonText: this.$t('MessageBox.Confirm'),
                cancelButtonText: this.$t('MessageBox.Cancel'),
            }).then(() => {
                Buy({
                    activity_id: this.localObjData.id,
                    buy_nums: this.value
                }, 'one').then(res => {
                    if (res.code == 10000) this.localObjData.slots_sold += this.value
                    Dialog.alert({message: res.message, confirmButtonText:this.$t('MessageBox.Confirm')})
                });
            }).catch(() => {
            });
        },
        // 获取单个商品售出的数量
        onUpdateSlotsSold(data) {
            if((this.localObjData.max_slots - this.localObjData.slots_sold) <= 0) return;
            if (this.localObjData.id === data.activity_id && typeof data.buy_nums === 'number' && store.state.member.info.member_id != data.member_id) {
                this.localObjData.slots_sold += data.buy_nums;
            }
        }
    }
}
</script>

<style scoped lang="scss">
.activity_tips{
    position: absolute;
    top: 0;
    left: 0;
    font-size: 14px;
    width: 100%;
    height: 205px;
    background: #000000b0;
    z-index: 99;
    text-align: center;
    border-radius: 8px;
    color: #fff;
    .tips_txt{margin-top:87px;}
}
.flex {
    display: flex;
}
.phase-sn{
    grid-column: span 2;
    text-align: center;
    overflow: hidden;
    margin-right: 10px;
}
.goods_des {
    overflow-y: auto;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .title {
        align-items: center;
        justify-content: space-between;

        .title_t {
            font-size: 14px;
            color: #000;
            font-weight: bold;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;

            img {
                margin-right: 5px;
                width: 8px;
                height: 14px;
            }

            div {
                position: absolute;
                left: 0;
                bottom: -5px;
                width: 100%;
                height: 5px;
                background: linear-gradient(90deg, #F21D19 0%, #FFF5F4 100%);
                border-radius: 8px;
            }
        }

        .title_x {
            cursor: pointer;

            svg {
                width: 20px;
                height: 20px;
            }
        }
    }

    .goods {
        margin: 20px 0 0;
        .goods_box {
            position: relative;
            display: flex;
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 10px;
            border-radius: 8px;
            border: 1px solid #F45C1D;
            background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
            display: flex;
            flex-direction: column;

            .goods_box_tie {
                color: #666666;
                font-size: 12px;
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
                .countdown{color:#E8090C;}
            }

            .goods_box_le {
                img {
                    width: 100px;
                    height: 58px;
                    -o-object-fit: contain;
                    object-fit: contain;
                    margin-bottom: 5px;
                    margin-right: 15px;
                    box-sizing: border-box;
                    border: 1px solid #ccc;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-radius: 5px;
                    background: #fff;
                }

                display: flex;

                .goods_box_le_text {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;

                    div {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-line-clamp: 3;
                    }

                    span {
                        color: #EA190F;
                        font-size: 12px;
                    }
                }

                font-size: 12px;
            }

            .goods_box_ri {
                margin-top: 5px;
                flex: 1;
                display: flex;
                flex-direction: column;

                .progress {
                    height: 8px;
                    background: #c10714;
                    border: 1px solid #DBDBDB;
                    position: relative;
                    border-radius: 8px;

                    span {
                        height: 10px;
                        background: url('../../../assets/image/one/Announced_4A.gif') center center repeat-x;
                        position: absolute;
                        top: -1px;
                        left: -1px;
                        font-size: 0;
                        border-radius: 8px;
                    }
                }

                .goods_box_ri_box {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    // gap: 20px;
                    font-size: 12px;
                    flex: 1;
                    margin-top: 10px;
                    text-align: center;
                }

                .goods_box_ri_btn {
                    padding: 20px 20px 10px;
                    box-sizing: border-box;
                    display: grid;
                    grid-template-columns: repeat(1, 1fr);
                    gap: 10px;
                    text-align: center;
                    font-size: 12px;
                    // div{
                    //     width: 100%;
                    //     margin: 10px auto 0;
                    //     background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
                    //     border-radius: 22px;
                    //     color: #fff;
                    //     font-size: 12px;
                    //     padding: 2px 0;
                    // }
                }
            }

            .buy_box {
                margin-bottom: 10px;
                font-size: 12px;
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                // gap: 20px;
                align-items: center;

                .btn {
                    width: 80%;
                    justify-self: end;
                    background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
                    border-radius: 22px;
                    color: #fff;
                    font-size: 12px;
                    padding: 10px 0;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }

        .buy {
            border-radius: 8px;
            border: 1px solid #F45C1D;
            background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
            padding: 10px 5px;
            box-sizing: border-box;

            .buy_title {
                text-align: center;
                font-weight: bold;
                font-size: 12px;
                margin-bottom: 10px;
            }

            .buy_box {
                margin-bottom: 10px;
                font-size: 12px;
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                align-items: center;

                .btn {
                    width: 80%;
                    justify-self: end;
                    background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
                    border-radius: 22px;
                    color: #fff;
                    font-size: 12px;
                    padding: 10px 0;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>